import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from './core/core.module';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { MatNativeDateModule } from '@angular/material/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { LogService } from './services/log/log.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { RoutestateService } from './tools/routestate/routestate.service';
import { TrackService } from './services/track/track.service';
import { InitAppService } from 'src/app/services/init-app/init-app.service';
import { MatDialogModule } from '@angular/material/dialog';

export function checkLandingUsage(InitAppService: InitAppService) {
  return (): Promise<any> => {
    return InitAppService.CheckLandingUsage();
  };
}

export function setClientOrigin(InitAppService: InitAppService) {
  return (): Promise<any> => {
    return InitAppService.SetClientOrigin();
  };
}

export function setClientEnv(InitAppService: InitAppService) {
  return (): Promise<any> => {
    return InitAppService.SetClientEnv();
  };
}

export function translationInitializer(InitAppService: InitAppService) {
  return () => {
    return InitAppService.InitLanguage();
  };
}

export function siteSource(InitAppService: InitAppService) {
  return () => {
    return InitAppService.setSiteSource();
  };
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new MultiTranslateHttpLoader(httpClient, [{ prefix: environment.multisite.apiresources, suffix: '.json' }]);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    MatNativeDateModule,
    HttpClientModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: checkLandingUsage, deps: [InitAppService], multi: true },
    { provide: APP_INITIALIZER, useFactory: setClientOrigin, deps: [InitAppService], multi: true },
    { provide: APP_INITIALIZER, useFactory: setClientEnv, deps: [InitAppService], multi: true },
    { provide: APP_INITIALIZER, useFactory: translationInitializer, deps: [InitAppService], multi: true },
    { provide: APP_INITIALIZER, useFactory: siteSource, deps: [InitAppService], multi: true },
    { provide: ErrorHandler, useClass: LogService },
    RoutestateService,
    TrackService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(protected stateService: RoutestateService) {}
}
